export default __webpack_public_path__ + "static/media/plus.ba8644cb.png";